module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/home-coworking-8e4c0ee7db0b432aa44d12786e9eab2c.png";